import axios from './axios';

const typesDef = {
  KEY: 'KEY',
  ACTION: 'ACTION',
  PATCH: 'PATCH',
};

const postAction = ({ socket, id, act, text }) => {
  socket.send(
    JSON.stringify({
      textId: id,
      act: act,
      text: text,
      timestamp: Date.now(),
      type: typesDef.ACTION,
    })
  );
};

const postKey = ({ socket, id, keyCode, selectionStart, selectionEnd }) => {
  socket.send(
    JSON.stringify({
      textId: id,
      keyCode: keyCode,
      selectionStart: selectionStart,
      selectionEnd: selectionEnd,
      timestamp: Date.now(),
      type: typesDef.KEY,
    })
  );
};

const postPatch = (socket, id, patch) => {
  socket.send(
    JSON.stringify({
      textId: id,
      position: patch.position,
      original: patch.original,
      replace: patch.replace,
      timestamp: Date.now(),
      type: typesDef.PATCH,
    })
  );
};

const putText = (textId, author, title, text) => {
  return axios.put(
    '/text',
    {
      author,
      title,
      text,
    },
    {
      params: {
        textId,
      },
    }
  );
};

const dataUtils = {
  postAction,
  postKey,
  postPatch,
  putText,
};

export default dataUtils;
